<div class="cpf" [class.cpf-disabled]="disabled">
  <!-- Vista previa interactiva. Es solo visual (aria-hidden): los campos de
       abajo son los accesibles. Tocar una zona lleva al campo que la llena;
       al escribir el CVC la tarjeta gira y muestra el reverso. -->
  <div class="cpf-stage" aria-hidden="true">
    <div class="cpf-card" [class.is-flipped]="flipped" [attr.data-brand]="brand">
      <div class="cpf-face cpf-front">
        <div class="cpf-row cpf-top">
          <span class="cpf-chip"></span>
          <span class="cpf-brand" [class.cpf-brand-empty]="!brand">{{ brandLabel || 'Tarjeta' }}</span>
        </div>
        <div class="cpf-zone cpf-number" [class.is-active]="activeField === 'cardNumber'" (click)="numberInput.focus()">{{ previewNumber }}</div>
        <div class="cpf-row cpf-bottom">
          <div class="cpf-zone cpf-holder" [class.is-active]="activeField === 'cardholderName'" (click)="nameInput.focus()">
            <small>Titular</small>
            <span>{{ previewName }}</span>
          </div>
          <div class="cpf-zone cpf-exp" [class.is-active]="activeField === 'expiry'" (click)="expiryInput.focus()">
            <small>Vence</small>
            <span>{{ previewExpiry }}</span>
          </div>
        </div>
      </div>
      <div class="cpf-face cpf-back" (click)="cvcInput.focus()">
        <span class="cpf-stripe"></span>
        <div class="cpf-sign">
          <span class="cpf-sign-lines"></span>
          <span class="cpf-zone cpf-cvc-box" [class.is-active]="activeField === 'cvc'">{{ previewCvc }}</span>
        </div>
        <small class="cpf-back-note">Código de seguridad (CVC)</small>
      </div>
    </div>
  </div>

  <div class="cpf-fields">
    <div class="cpf-group">
      <label [for]="idPrefix + 'CardNumber'">Número de tarjeta</label>
      <div class="cpf-control" [class.has-error]="hasError('cardNumber')">
        <i class="bi bi-credit-card-2-front" aria-hidden="true"></i>
        <input data-no-limit-hint #numberInput type="text" [id]="idPrefix + 'CardNumber'" [value]="cardNumber" [disabled]="disabled"
          (input)="onNumberInput($event)" (focus)="setActive('cardNumber')" (blur)="setActive(null)"
          placeholder="1234 5678 9012 3456" inputmode="numeric" maxlength="29" autocomplete="cc-number"
          [attr.aria-invalid]="hasError('cardNumber')" [attr.aria-describedby]="hasError('cardNumber') ? idPrefix + 'CardNumberError' : null">
        <span class="cpf-badge" *ngIf="brand">{{ brandLabel }}</span>
      </div>
      <small class="cpf-error" [class.is-visible]="hasError('cardNumber')" [id]="idPrefix + 'CardNumberError'"
        [attr.aria-hidden]="!hasError('cardNumber')" aria-live="polite">{{ fieldError('cardNumber') }}</small>
    </div>

    <div class="cpf-group">
      <label [for]="idPrefix + 'CardholderName'">Nombre del titular</label>
      <div class="cpf-control" [class.has-error]="hasError('cardholderName')">
        <i class="bi bi-person" aria-hidden="true"></i>
        <input data-no-limit-hint #nameInput type="text" [id]="idPrefix + 'CardholderName'" [value]="cardholderName" [disabled]="disabled"
          (input)="onNameInput($event)" (focus)="setActive('cardholderName')" (blur)="setActive(null)"
          placeholder="Como aparece en la tarjeta" maxlength="80" autocomplete="cc-name"
          [attr.aria-invalid]="hasError('cardholderName')" [attr.aria-describedby]="hasError('cardholderName') ? idPrefix + 'CardholderNameError' : null">
      </div>
      <small class="cpf-error" [class.is-visible]="hasError('cardholderName')" [id]="idPrefix + 'CardholderNameError'"
        [attr.aria-hidden]="!hasError('cardholderName')" aria-live="polite">{{ fieldError('cardholderName') }}</small>
    </div>

    <div class="cpf-split">
      <div class="cpf-group">
        <label [for]="idPrefix + 'ExpireDate'">Vencimiento</label>
        <div class="cpf-control" [class.has-error]="hasError('expiry')">
          <i class="bi bi-calendar-event" aria-hidden="true"></i>
          <input data-no-limit-hint #expiryInput type="text" [id]="idPrefix + 'ExpireDate'" [value]="expireDate" [disabled]="disabled"
            (input)="onExpiryInput($event)" (focus)="setActive('expiry')" (blur)="setActive(null)"
            placeholder="MM/AA" inputmode="numeric" maxlength="5" autocomplete="cc-exp"
            [attr.aria-invalid]="hasError('expiry')" [attr.aria-describedby]="hasError('expiry') ? idPrefix + 'ExpireDateError' : null">
        </div>
        <small class="cpf-error" [class.is-visible]="hasError('expiry')" [id]="idPrefix + 'ExpireDateError'"
          [attr.aria-hidden]="!hasError('expiry')" aria-live="polite">{{ fieldError('expiry') }}</small>
      </div>
      <div class="cpf-group">
        <label [for]="idPrefix + 'Cvc'">CVC</label>
        <div class="cpf-control" [class.has-error]="hasError('cvc')">
          <i class="bi bi-lock" aria-hidden="true"></i>
          <input data-no-limit-hint #cvcInput type="password" [id]="idPrefix + 'Cvc'" [value]="cvc" [disabled]="disabled"
            (input)="onCvcInput($event)" (focus)="setActive('cvc')" (blur)="setActive(null)"
            placeholder="•••" inputmode="numeric" maxlength="4" autocomplete="cc-csc"
            [attr.aria-invalid]="hasError('cvc')" [attr.aria-describedby]="hasError('cvc') ? idPrefix + 'CvcError' : idPrefix + 'CvcHelp'">
        </div>
        <small class="cpf-error" [class.is-visible]="hasError('cvc')" [id]="idPrefix + 'CvcError'"
          [attr.aria-hidden]="!hasError('cvc')" aria-live="polite">{{ fieldError('cvc') }}</small>
      </div>
    </div>
    <small class="cpf-help" [id]="idPrefix + 'CvcHelp'">CVC: 3 dígitos al reverso de la tarjeta (4 al frente en AMEX).</small>
  </div>
</div>
